import { createSelector } from 'reselect';

const getDashboard = (state) => state.dashboard.get('data');

export const getDashboardMeta = createSelector(
  [getDashboard],
  (dashboard) => {
    return dashboard.toJS();
  }
);
